import React, { useState } from 'react'
import { deleteBatch } from '../../../../../../../services/receivement/receivementService'
import ModalDeleteBatch from '../../components/ModalDeleteBatch'

export const useDeleteModal = ({ setTableData, operatorBadge }) => {
  const [deleteObject, setDeleteObject] = useState()

  const handleBatachDeleteOnClick = (batch) => {
    setDeleteObject(batch)
  }

  const handleBatchDelete = (batchId) => {
    deleteBatch(operatorBadge, batchId)
      .then(() => {
        setDeleteObject()
        setTableData((td) => td.filter((v) => v.batchId !== batchId))
      })
      .catch((e) => {
        alert('Problema ao excluir o lote')
        console.error(e)
      })
  }

  const DeleteModalComponent = () => (
    <ModalDeleteBatch
      deleteObject={deleteObject}
      cancelAction={() => setDeleteObject()}
      deleteAction={() => handleBatchDelete(deleteObject?.batchId)}
    />
  )

  return {
    handleBatachDeleteOnClick,
    DeleteModalComponent
  }
}
